import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-2"
}
const _hoisted_2 = { class: "flex justify-evenly" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "mt-5" }

import { onMounted, computed, ref } from 'vue';
import { useUserStore } from '@/store/users';
import PinnedStat from '@/components/Statistics/PinnedStat.vue';
import UnpinnedStat from '@/components/Statistics/UnpinnedStat.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();
const statistics = ref();

const viewedUser = computed(() => userStore.secureUser || userStore.viewUser);

onMounted(async () => {
  if (viewedUser.value) {
    const userId = viewedUser.value.Uuid;
    statistics.value = await userStore.getStatistics(userId);
  }
});

return (_ctx: any,_cache: any) => {
  return (statistics.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statistics.value.Pinned, (stat) => {
            return (_openBlock(), _createBlock(PinnedStat, {
              key: stat.text,
              text: stat.text,
              value: stat.value
            }, null, 8, ["text", "value"]))
          }), 128))
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statistics.value.Unpinned, (stat) => {
            return (_openBlock(), _createBlock(UnpinnedStat, {
              key: stat.text,
              text: stat.text,
              value: stat.value
            }, null, 8, ["text", "value"]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})